import { Location } from '@angular/common';
import {
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { 
  ActivatedRoute,
  Router,
} from '@angular/router';
import { IonContent,AlertController,ActionSheetController, MenuController,LoadingController, ModalController,AnimationController, Platform } from '@ionic/angular';

import { Storage } from '@ionic/storage-angular';
import { CartService } from 'src/app/services/cart.service';
import { PopupAttributePage } from 'src/app/pages/popup-attribute/popup-attribute.page';
import { DataService } from 'src/app/services/data.service';
import { VariantMappingComponent } from 'src/app/components/add-inventory-management/variant-mapping/variant-mapping.component';
import { PriceDetailComponent } from '../price-detail/price-detail.component';


@Component({
  selector: 'app-add-price',
  templateUrl: './add-price.component.html',
  styleUrls: ['./add-price.component.scss'],
})
export class AddPriceComponent  implements OnInit {

  // @Input() product_list;
  // @Output() submit = new EventEmitter();
  // cat_products:any = [];
  wishcart_items = [];
  cart_len;
  no_products = false;
  page_no = 1;
  choosed_product_name;
  sort = '';
  sort_text;
  drop_down2 = false;
  ids = '';
  category_filters;
  category_child;
  mobile_child;
  // skeleton = true;
  sortby_drop_down = false;
  @ViewChild('dropdown2', { read: ElementRef }) dropdown2:any = ElementRef;
  @ViewChild(IonContent) private content:any = IonContent;
  @ViewChild('scrollMe')scrollMe!:ElementRef;
  tableID;
  all_products: any = [];
  searchmenuitems: any = [];
  active;
// updates
   is_show_price_detail: any;
   product_detail: any;
   @Input() product_list:any;
   @Input() centre:any;
   loader:any;
   index:any;
   ele_index:any;
   botton_name = 'edit';
   selected_index;
   subscribe:any;

  //  column:any = [{label:"Product Name",field:'product_name'},{label:'Centre',field:'centre'},{label:'SKU',field:'sku'},
  //  {label:'Old Price',field:'old_price'},{label:'New Price',field:'price'}]
  // public pos: PosPage,
  constructor(public storage: Storage,public ngcart: CartService, public db: DataService, private router: Router, private route: ActivatedRoute, private modalCtrl: ModalController, private alertCtrl: AlertController, private platform: Platform, private location: Location, private actionSheetCtrl: ActionSheetController,private animationCtrl: AnimationController) {
  }

  ngOnInit() {

    this.subscribe = this.db.price_submit.subscribe(res=>{
      // console.log(res);
      if(res && res['status'] == 'Success'){
        delete res['status'];
        this.update_price(res); 
      }
    })

    this.no_products = false;
    this.db.choosed_product_id = undefined;

    this.db.ismobile = this.db.checkmobile();
    this.get_all_category();

    this.db.skeleton_pricing = true;
    this.db.price__search_txt = '';
    this.db.centre = '';
    this.db.price__category = '';
    this.db.price_page_no = 1;
    this.db.no_price__products = false;
    this.db.product_list = [];

    this.get_all_products();
    // this.db.get_inventory_products();
    // this.route.params.subscribe((res:any) => {
    //   if (res.product && !res.product_1 && !res.product_2) {
    //     this.db.choosed_product_id = this.route.snapshot.paramMap.get('product'); //for api call
    //     this.db.childs.child_1 = this.db.choosed_product_id // store child-1
    //     this.db.childs.child_2 = undefined
    //     this.db.childs.child_3 = undefined
    //     this.db.childs.child_2_name = undefined
    //     this.db.childs.child_3_name = undefined
    //   } else if (res.product && res.product_1 && !res.product_2) {
    //     this.db.choosed_product_id = this.route.snapshot.paramMap.get('product_1');
    //     this.db.childs.child_2 = this.db.choosed_product_id
    //     this.db.childs.child_1 = res.product
    //     this.db.childs.child_3 = undefined
    //     this.db.childs.child_3_name = undefined
    //   } else if (res.product && res.product_1 && res.product_2) {
    //     this.db.choosed_product_id = this.route.snapshot.paramMap.get('product_2');
    //     this.db.childs.child_3 = this.db.choosed_product_id
    //     this.db.childs.child_1 = res.product
    //     this.db.childs.child_2 = res.product_1
    //   }
    // })
    // this.db.choosed_brands = [];
    // this.db.choosed_attributes = [];
  }

  ngOnDestroy(): void {
    this.subscribe.unsubscribe();
  }

  @HostListener('window:resize', ['$event'])
  private func() {
    this.db.ismobile = this.db.checkmobile();
  }
  
  ionViewWillEnter() {
    this.content.scrollToTop();
  }

  @HostListener('window:keydown', ['$event'])
   checkKey(event:KeyboardEvent) {
     if(event.key == 'ArrowDown'){
      if(this.product_list[this.ele_index + 1]){
        this.ele_index +=1        
        this.scrollToDiv()
      }
     }else if(event.key == 'ArrowUp'){
      if(this.product_list[this.ele_index - 1]){
      this.ele_index -=1
      this.scrollToDiv()
      }
     }
  }
  
  smoothscroll() {
    let check = document.getElementById("content") as HTMLInputElement
    check.scrollIntoView({ behavior: 'smooth' });
  }

  // closePriceDetail(event){
  //   this.is_show_price_detail = false;
  //   console.log(this.is_show_price_detail);
    
  // }
  loadData(event) {
    // console.log(event);
    // console.log(event.target.offsetHeight + event.target.scrollTop);
    let value = event.target.offsetHeight + event.target.scrollTop + 1;
    value = value.toFixed() ;

    if(value >= event.target.scrollHeight){

      if(!this.db.no_price__products){
        this.db.price_page_no = this.db.price_page_no + 1;
        this.db.get_products_list();
      }

    }
  }

  onScroll(event:any){
    if(event.target.offsetHeight + event.target.scrollTop >= event.target.scrollHeight){
      this.db.price_page_no += 1;
      console.log(this.db.price_page_no)
      this.get_all_products();
    }
  }

  get_cat_products(sort) {
    this.is_show_price_detail = false;
    this.db.price_page_no = 1;
    this.db.no_price__products = false;
    this.db.price__category = (sort == 'All') ? '' : sort;
    this.db.get_products_list();
    // this.loader=true
    // let data = {
    //   category: sort == 'All' ? '' : sort,
    //   page_no:1
    // }
    // this.db.get_products_for_pricing(data)
    //   .subscribe((res:any)=>{
    //     if(res.message && res.message.length != 0){
    //       this.product_list = res.message;
    //       this.loader=false
    //     }else{
    //       this.product_list = []
    //       this.loader=false
    //     }
    //   })
    // this.db.get_inventory_products();
  }

  added_product_list(select_item){
 
    console.log(select_item)
    

  //  let obj = { 'product_id':select_item.name,'attribute_id':select_item.attribute_id};

      // if(select_item.variants && select_item.variants.length == 0){
      //  if(this.db.inventory_items.length == 0){
      //   select_item['Added_to_inventory'] = 1;
      //   this.db.inventory_items.push(select_item);
      //   // this.db.selected_items.push(obj);
      //   }else if(!select_item['Added_to_inventory']){
      //     select_item['Added_to_inventory'] = 1;
      //     this.db.inventory_items.push(select_item);
      //   //  this.db.selected_items.push(obj);
      //   }
      //   this.storage.set('inventroy_items', this.db.inventory_items);
      // }else{
      //    this.open_variants_pop_up(select_item)
      // }
  }

  //Emitted from price-detail com
  add_price(event:any){
    this.index = event.index
    this.update_price(event.message);
  }
  scrollToDiv(){
    let id = 'product_'+this.ele_index
    let list_element:any = document.getElementById(id)
    list_element.scrollIntoView({behavior: 'smooth',block:'start'})
      this.product_list.map((product:any,i:any)=>{
      if(i==this.ele_index){
       product.active = true
       this.db.is_show = false
       setTimeout(()=>{
        this.product_detail = product
        this.db.is_show = true
        this.db.add_price.next({'message':this.product_detail,'index':this.ele_index})
         },100)       
      }else{ product.active = false}
   })
  }
  



  async open_variants_pop_up(select_item) {
 
    const modal = await this.modalCtrl.create({   
      component: VariantMappingComponent,
      cssClass: 'job-detail-popup',
      componentProps:{
        product_values:select_item
      },
      enterAnimation: this.enterAnimation,
      leaveAnimation: this.leaveAnimation,
     })
     await modal.present();

     const { data } = await modal.onWillDismiss();
      if (data && data.status && data.status == 'success') {
        
      }
  } 

  // ion-model slide left transaction
  enterAnimation = (baseEl: HTMLElement) => { 
    var root:any = baseEl.shadowRoot;
    const backdropAnimation = this.animationCtrl
      .create()
      .addElement(root.querySelector('ion-backdrop')!)
      .fromTo('opacity', '0.01', 'var(--backdrop-opacity)');

    const wrapperAnimation = this.animationCtrl
      .create()
      .addElement(root.querySelector('.modal-wrapper')!)
      .keyframes([
        { offset: 0, opacity: '0.09', transform: 'translateX(100%)' },
        { offset: 1, opacity: '1', transform: 'translateX(0)' },
      ]);
    return this.animationCtrl
      .create()
      .addElement(baseEl)
      .easing('ease-out')
      .duration(500)
      .addAnimation([backdropAnimation, wrapperAnimation]);
  };

  leaveAnimation = (baseEl: HTMLElement) => {
    return this.enterAnimation(baseEl).direction('reverse');
  };


  get_all_category(){
    var data = {
      domain: this.db.domain,
      show_count:1,
      business:localStorage['business']
    }
    this.db.product_category(data).subscribe((data:any) => {
      this.db.category = data.message;
    }, error => { console.log(JSON.stringify(error.json())); });
  }

 
  
  get_all_products(){
    this.db.get_products_list();
  //   let payload = {
  //     centre:this.centre ? this.centre : '',
  //     page_no: this.page_no,
  //     page_size: 10,
  //     // "category": "",
  //     // "search_txt": ""
  // }
  // // get_products_for_pricing
  // this.db.get_products_for_pricing(payload).subscribe(res=>{
  //   if(res.message && res.message.length != 0){
  //    if(this.page_no == 1){
  //     this.product_list = this.page_no == 1 ? res.message : []
  //    }else{
  //     this.product_list = [...this.product_list,...res.message]
  //    }
  //   }
  // })
  }

  @HostListener('document:keyup', ['$event'])
  handleKeyboardEvent(event) {
    let key = event.key;
    if (key == 'ArrowDown') {
      // this.arrow_down_fn(this.pos.current_active);
    } else if (key == 'ArrowUp') {
      // this.arrow_up_fn(this.pos.current_active);
    }
    this.shortcuts(event);
  }

  arrow_down_fn(current_active) {
    let cur_active = this.active;
    // if (this.pos.current_active == 'search') {
      if ((cur_active + 1) < this.searchmenuitems.length) {
        this.active = cur_active + 1;
        let check = document.getElementById(this.active + '_scroll') as HTMLInputElement
        check.scrollIntoView({ behavior: "smooth", block: "center", inline: "nearest" });
      }
    // }
  }

  arrow_up_fn(current_active) {
    let cur_active = this.active;
    // if (this.pos.current_active == 'search') {
      if ((cur_active - 1) < this.searchmenuitems.length && (cur_active - 1) != -1) {
        this.active = cur_active - 1;
        let check = document.getElementById(this.active + '_scroll') as HTMLInputElement
        check.scrollIntoView({ behavior: "smooth", block: "center", inline: "nearest" });

      // }
    }
  }

  shortcuts(event) {
    if (event.keyCode == 13) {
      event.preventDefault(); // prevent default function of Enter
    }
  }

  // async showProductDetail(select_item,index){
  //   //active item
  //   this.product_list.map((product:any,i:any)=>{
  //      if(i==index){
  //       product.active = true
  //      }else{ 
  //       product.active = false
  //     }
  //   })

  //   if(select_item){
  //     this.is_show_price_detail = true;
  //     this.selected_index = index;
  //     // this.db.is_show = false;
  //     if(this.db.ismobile){
  //       this.product_detail = select_item;
  //       // this.db.is_show = true;
  //     }else{
  //       setTimeout(() => {
  //         this.product_detail = select_item;
  //         this.db.add_price.next({'message':this.product_detail,'index':index})
  //         // this.db.is_show = true;
  //       }, 400);
  //     }
  //     //get element
  //     this.ele_index = index
  //     this.scrollToDiv()
  //   }
  //   if(this.db.ismobile){
  //     let form = await this.modalCtrl.create({
  //       component: PriceDetailComponent,
  //       cssClass: 'slide-75',
  //       componentProps:{
  //         product_detail: select_item
  //       }
  //     });
  
  //     form.present();
  
  //     let data = await form.onWillDismiss()
  //     if(data && data.data){
  //       // console.log(data)
  //       this.update_price(data.data) 
  //     }
  //   }
  // }

  // update_price(event:any){
  //   let arr:any = [];
  //   if(event.variants && event.variants.length != 0){
  //     for(let i=0;i<event.variants.length;i++){
  //       if(event.variants[i].old_price !=0 || event.variants[i].price !=0 ){
  //         let data = {
  //           attribute_id: event.variants[i].attribute_id,
  //           old_price: event.variants[i].old_price,
  //           price: event.variants[i].price,
  //           // from_date: ''
  //         }
  //         arr.push(data);
  //       }
  //     }
  //   }

  //   let data ={
  //     warehouse:event.centre,
  //     product:event.product_id,
  //     old_price: event.variants.length == 0 ? event.old_price : 0,
  //     price: event.variants.length == 0 ? event.price : 0,
  //     business: localStorage['business'],
  //     // attribute_id: event.attribute_id ? event.attribute_id :'',
  //     variants: arr && arr.length != 0 ? arr : ''
  //   }
  //   // console.log(data)
  //   this.db.update_product_prices(data)
  //   .subscribe((res:any)=>{
  //     if(res.message.status == 'Success'){
  //       // this.is_show_price_detail = false;
  //       this.product_list[this.index] = event;
  //     }
  //     // console.log(res)
  //   })
  // }

  async showProductDetail(select_item,index){
    this.product_list.map((product:any,i:any)=>{
      if(i == index){
       product.active = true
      }else{ 
       product.active = false
     }
   })

    if(select_item){
      this.db.botton_name = 'price';
      this.is_show_price_detail = true;
      this.selected_index = index;
      this.ele_index = index;
      this.index = index;
      if(this.db.ismobile){
        this.router.navigateByUrl('/manage-price?product='+ select_item.name) 
        // let form = await this.modalCtrl.create({
        //   component: PriceDetailComponent,
        //   cssClass: 'job-detail-popup',
        //   componentProps:{
        //     product_detail: select_item
        //   }
        // });

        // // this.db.modals.push(form);
        // form.present();
        // let data = await form.onWillDismiss()
        // if(data && data.data){
        //   this.update_price(data.data) 
        // }
        

      }else{
        this.db.view == 'list' ? this.scrollToDiv() : null;
        this.db.is_show = false;
        setTimeout(() => {
          this.product_detail = select_item;
          this.db.is_show = true;
          // this.db.add_price.next({'message':this.product_detail,'index':index})
        }, 400);
      }
    }
  // }
  // else{    
  //   this.db.get_product_details(select_item.product_id).subscribe(res=>{
  //     this.db.edit_product_value = res.message
  //     this.db.product_detail.next(res.message);
  //   })
  // }
  }

  update_price(event:any){
    let arr:any = [];
    // if(event.variants && event.variants.length != 0){
    //   event.variants.map(res=>{
    //     if(res.old_price != 0 || res.price != 0){
    //       let data = {
    //         attribute_id: res.attribute_id,
    //         old_price: res.old_price,
    //         price: res.price,
    //         // from_date: ''
    //       }
    //       arr.push(data);
    //     }
    //   })
    // }

    if(event.updated_variants && event.updated_variants.length != 0){
      event.updated_variants.map(res=>{
        // if(res.old_price != 0 || res.price != 0){
          let data = {
            attribute_id: res.attribute_id,
            old_price: res.old_price,
            price: res.price,
            // from_date: ''
          }
          arr.push(data);
        // }
      })
    }

    let data ={
      warehouse:event.centre,
      product:event.product_id,
      old_price: event.variants.length == 0 ? event.old_price : 0,
      price: event.variants.length == 0 ? event.price : 0,
      business: localStorage['business'],
      // attribute_id: event.attribute_id ? event.attribute_id :'',
      variants: (arr && arr.length != 0) ? arr : ''
    }
    this.db.update_product_prices(data).subscribe((res:any)=>{
      if(res.message.status == 'Success'){
        // this.db.alert('Product price was updated successfully')
        this.db.alert_animate.next('Product price was updated successfully');
        // this.product_list[this.index] = event;
        let data = res.message.data;
        data.active = true;
        data.status = 'price_updated';
        this.product_list[event.selected_index] = data;
        this.db.price_submit.next(this.product_list[event.selected_index]);
      }
    })
  }


  // btn_change(type){
  //   if(type == 'edit'){
      
  //   }else if(type == 'price'){
  //     this.db.is_show = true;
  //     this.db.add_price.next({'message':this.product_detail,'index':this.selected_index})
  //   }
  //   this.botton_name = type
  // }

}
